import {
  DEFAULT_JOURNAL_MODE,
  DEFAULT_SYNCHRONOUS,
  applyOpfsPragmas,
  checkpointWal
} from "./chunk-6A53PZGM.mjs";
import {
  __export
} from "./chunk-J5LGTIGS.mjs";

// src/OpfsWorker.ts
var OpfsWorker_exports = {};
__export(OpfsWorker_exports, {
  run: () => run
});
import * as WaSqlite from "@dxos/wa-sqlite";
import SQLiteESMFactory from "@dxos/wa-sqlite/dist/wa-sqlite.mjs";
import * as Effect from "effect/Effect";
import * as SqlError from "effect/unstable/sql/SqlError";
import { log } from "@dxos/log";
import { AccessHandlePoolVFS } from "@dxos/wa-sqlite/src/examples/AccessHandlePoolVFS.js";
var __dxlog_file = "/__w/dxos/dxos/packages/common/sql-sqlite/src/OpfsWorker.ts";
var run = (options) => Effect.gen(function* () {
  const factory = yield* Effect.promise(() => SQLiteESMFactory());
  const sqlite3 = WaSqlite.Factory(factory);
  const vfs = yield* Effect.promise(() => AccessHandlePoolVFS.create("opfs", factory));
  sqlite3.vfs_register(vfs, false);
  let shutdownRequested = false;
  const db = yield* Effect.acquireRelease(Effect.try({
    try: () => {
      const handle = sqlite3.open_v2(options.dbName, void 0, "opfs");
      applyOpfsPragmas(sqlite3, handle, {
        journalMode: options.journalMode ?? DEFAULT_JOURNAL_MODE,
        synchronous: options.synchronous ?? DEFAULT_SYNCHRONOUS
      });
      return handle;
    },
    catch: (cause) => new SqlError.SqlError({
      reason: SqlError.classifySqliteError(cause, {
        message: "Failed to open database"
      })
    })
  }), (handle) => Effect.sync(() => {
    sqlite3.close(handle);
    if (shutdownRequested) {
      options.port.postMessage([
        "closed",
        void 0,
        void 0
      ]);
    }
  }));
  return yield* Effect.callback((resume) => {
    const onMessage = (event) => {
      let messageId;
      let lastSql;
      let lastParams;
      const message = event.data;
      try {
        switch (message[0]) {
          case "close": {
            shutdownRequested = true;
            return resume(Effect.void);
          }
          case "import": {
            const [, id, data] = message;
            messageId = id;
            log("opfs import", {
              bytes: data.byteLength
            }, { "~LogMeta": "~LogMeta", F: __dxlog_file, L: 78, S: this });
            sqlite3.deserialize(db, "main", data, data.length, data.length, 1 | 2);
            for (const stmt of sqlite3.statements(db, "VACUUM")) {
              let result = sqlite3.step(stmt);
              while (result === WaSqlite.SQLITE_ROW) {
                result = sqlite3.step(stmt);
              }
              if (result !== WaSqlite.SQLITE_DONE) {
                throw new Error("VACUUM failed while persisting imported database");
              }
            }
            applyOpfsPragmas(sqlite3, db, {
              journalMode: options.journalMode ?? DEFAULT_JOURNAL_MODE,
              synchronous: options.synchronous ?? DEFAULT_SYNCHRONOUS
            });
            options.port.postMessage([
              id,
              void 0,
              void 0
            ]);
            return;
          }
          case "export": {
            const [, id] = message;
            messageId = id;
            checkpointWal(sqlite3, db);
            const data = sqlite3.serialize(db, "main");
            options.port.postMessage([
              id,
              void 0,
              data
            ], [
              data.buffer
            ]);
            return;
          }
          case "update_hook": {
            messageId = -1;
            sqlite3.update_hook(db, (_op, _db, table, rowid) => {
              if (!table) {
                return;
              }
              options.port.postMessage([
                "update_hook",
                table,
                Number(rowid)
              ]);
            });
            return;
          }
          default: {
            const [id, sql, params] = message;
            messageId = id;
            lastSql = sql;
            lastParams = params;
            const results = [];
            const begin = performance.now();
            let columns;
            for (const stmt of sqlite3.statements(db, sql)) {
              sqlite3.bind_collection(stmt, params);
              while (sqlite3.step(stmt) === WaSqlite.SQLITE_ROW) {
                columns = columns ?? sqlite3.column_names(stmt);
                const row = sqlite3.row(stmt);
                results.push(row);
              }
            }
            options.port.postMessage([
              id,
              void 0,
              [
                columns,
                results
              ]
            ]);
            const end = performance.now();
            log("sqlite query", {
              sql,
              params,
              results: results.length,
              time: end - begin
            }, { "~LogMeta": "~LogMeta", F: __dxlog_file, L: 160, S: this });
            performance.measure(sql.slice(0, 128), {
              start: begin,
              end,
              detail: {
                devtools: {
                  dataType: "track-entry",
                  track: "Query",
                  trackGroup: "SQlite",
                  color: "tertiary-dark",
                  properties: [
                    [
                      "sql",
                      sql
                    ],
                    [
                      "params",
                      params
                    ],
                    [
                      "resultCount",
                      results.length
                    ]
                  ]
                }
              }
            });
            return;
          }
        }
      } catch (e) {
        log("sqlite error", {
          error: e,
          sql: lastSql,
          params: lastParams
        }, { "~LogMeta": "~LogMeta", F: __dxlog_file, L: 198, S: this });
        const message2 = "message" in e ? e.message : String(e);
        options.port.postMessage([
          messageId,
          message2,
          void 0
        ]);
      }
    };
    options.port.addEventListener("message", onMessage);
    options.port.postMessage([
      "ready",
      void 0,
      void 0
    ]);
    return Effect.sync(() => {
      options.port.removeEventListener("message", onMessage);
    });
  });
}).pipe(Effect.scoped);

export {
  run,
  OpfsWorker_exports
};
//# sourceMappingURL=chunk-BOAQ6QEW.mjs.map
